import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import './style.scss';
import { APPCHARGE_COOKIE_POLICY_URL } from '../../constants/defaults';
import { ELocalStorageKeys } from 'constants/enums';
import { useLoginState } from 'state/hooks/login.state.hook';
import Stack from '@mui/material/Stack';
import { webStorageUtil } from 'state/webStorage.state.service';
import CookieSettingsDialog from 'components/CookieSettingsDialog/CookieSettingsDialog';
import useAnalytics from '../../hooks/useAnalytics';

const CookieConsent: React.FC = () => {
  const { setShowCookiesOverlay, showCookieSettingsDialog, setShowCookieSettingsDialog } = useLoginState();
  const { optIn, optOut } = useAnalytics();

  const { t } = useTranslation();

  const openDialog = (event: React.SyntheticEvent) => {
    event.stopPropagation();
    setShowCookieSettingsDialog(true);
  };

  const saveSettings = () => {
    webStorageUtil.set(ELocalStorageKeys.ANALYTICS, JSON.stringify(true));
    optIn(); // Enable analytics services
    setShowCookiesOverlay(false);
  };

  const saveNecessaryCookiesSettings = () => {
    webStorageUtil.set(ELocalStorageKeys.ANALYTICS, JSON.stringify(false));
    optOut(); // Disable analytics services
    setShowCookiesOverlay(false);
  };

  const closeDialog = () => {
    setShowCookieSettingsDialog(false);
  };

  return (
    <div id="cookieConsent" onClick={closeDialog}>
      <CookieSettingsDialog
        open={showCookieSettingsDialog || false}
        onClose={closeDialog}
        onSave={() => setShowCookiesOverlay(false)}
        variant="inline"
      />
      <div className="cookies-banner">
        <Typography variant="subtitle1" component="p" align="center">
          <Trans i18nKey="cookieConsent.overallCookieConsentDescription">
            We use cookies to save information on your device. Some help make this site work, others
            to enhance your experience! You can accept all cookies or visit cookie settings to
            adjust your preference. See our
            <a target="_blank" href={APPCHARGE_COOKIE_POLICY_URL} rel="noreferrer">
              cookie policy
            </a>{' '}
            for more.
          </Trans>
        </Typography>
        <Stack direction="row" spacing={2}>
          <button className="adjust" onClick={openDialog}>
            {t('cookieConsent.adjustCookies')}
          </button>
          <button className="accept-necessary" onClick={saveNecessaryCookiesSettings}>
            {t('cookieConsent.acceptNecessary')}
          </button>
          <button className="accept" onClick={saveSettings}>
            {t('cookieConsent.acceptAll')}
          </button>
        </Stack>
      </div>
    </div>
  );
};

export default CookieConsent;
